import { render, staticRenderFns } from "./datatable_customer.vue?vue&type=template&id=46783c0b"
import script from "./datatable_customer.vue?vue&type=script&lang=js"
export * from "./datatable_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports